import { api } from "../config/config";
import { toast } from "react-toastify";

/**
 * Supprime un fichier du serveur.
 *
 * @param {string} file - Le nom ou le chemin du fichier à supprimer.
 * @param {Function} setIsLoading - Fonction pour mettre à jour l'état de chargement.
 * @returns {Promise<boolean>} - Renvoie `true` si la suppression est réussie, sinon `false`.
 */
export const handleDeleteFile = async (file, setIsLoading) => {
  setIsLoading(true);
  try {
    const response = await api.delete(`/storage/${file}`);
    return response.status === 201;
  } catch (error) {
    toast.error("Le fichier n'existe pas");
    return false;
  } finally {
    setIsLoading(false);
  }
};
